import React, { lazy, Suspense } from 'react';
import type { GQLLocale } from 'graphql-ts-types';

import { DrawerType } from '../../enums/Tracking';
import { useOpenDrawer } from '../../hooks/drawer';
import { useLocalization } from '../../providers/LocaleProvider';
import { dispatchTrackingEventGA4 } from '../../tracking/dispatchTrackingEventGA4';
import { DrawerInteraction, Element, TrackingEventName } from '../../types/tracking';
import { CenteredSpinner } from '../Spinner';
import { ZipCodeFormPlacement } from '../ZipCodeForm/event';

const ZipCodeDrawerContent = lazy(() => import('./index'));

type OnUpdate = (params: { zipCode: string; locale: GQLLocale }) => void | Promise<void>;

const trackDrawerClose = (type: DrawerType) =>
  dispatchTrackingEventGA4({
    event: TrackingEventName.CommonDrawerClick,
    common_disclaimer_type: type,
    interaction: DrawerInteraction.Close,
    element: Element.Button,
    button_text: 'Close',
  });

export const useOpenZipCodeDrawer = (
  onUpdate: OnUpdate,
  placement: ZipCodeFormPlacement = ZipCodeFormPlacement.CartSummary
) => {
  const { t } = useLocalization();
  const title = t('h24_enter_zip_code_header');

  const drawerType =
    placement === ZipCodeFormPlacement.GlobalHeader
      ? DrawerType.ZipCodeGlobalHeader
      : DrawerType.ZipCodeCartSummary;

  return useOpenDrawer({
    title,
    content: (
      <Suspense fallback={<CenteredSpinner />}>
        <ZipCodeDrawerContent onUpdate={onUpdate} placement={placement} />
      </Suspense>
    ),
    onCloseComplete: () => trackDrawerClose(drawerType),
  });
};
